"use strict";
/*
*
* 1) Simple usage:
*     <EmptyList title="Nenhuma atividade registrada"
*       subtitle="Que tal agendar uma ligação ou uma visita a um cliente? :)" />
*
*/
var BoldText = require("app/shared/components/BoldText/bold-text");

const EmptyList = (props) => (
  <div className="w-100 ta-c pt-40 pr-135 pb-70 pl-135 c-lightGrey">
    <p className="c-fontGray fw-normal" dangerouslySetInnerHTML={{__html: props.title}}></p>
    <p className="c-fontGray fw-normal"><BoldText text={props.subtitle} /></p>
    {props.children}
  </div>
);

EmptyList.propTypes = {
  title: React.PropTypes.string.isRequired,
  subtitle: React.PropTypes.string.isRequired,
  children: React.PropTypes.node
};

module.exports = EmptyList;



// WEBPACK FOOTER //
// ./app/shared/components/List/empty-list.jsx